import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import './index.scss';

const reqParams = '/overview/lifetime';

const Lifetime = () => (
  <>
    <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG} />
  </>
);

export default Lifetime;

